import React from 'react';
import _ from 'lodash';

import {formatDate} from 'utils/datetime';

import Table from 'components/Table';

const BreakClauseTable = ({primaryTenant, breakClause, period}) => {
  return (
    <Table simpleTable>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Tenant</Table.Cell>
          <Table.Cell>
            {_.get(primaryTenant, 'fullName', primaryTenant.email)}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Tenancy start date</Table.Cell>
          <Table.Cell>{formatDate(period.startDate)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Tenancy end date</Table.Cell>
          <Table.Cell>{formatDate(period.endDate)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Break clause type</Table.Cell>
          <Table.Cell>
            {breakClause.isFlexible === true && 'Flexible'}
            {breakClause.isFlexible === false && 'Fixed'}
            {breakClause.isFlexible === null && '-'}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Break clause period</Table.Cell>
          <Table.Cell>{breakClause.period}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Break clause notice</Table.Cell>
          <Table.Cell>{breakClause.noticePeriod}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Notice deadline</Table.Cell>
          <Table.Cell>
            {(breakClause.noticeDeadline &&
              formatDate(breakClause.noticeDeadline)) ||
              '-'}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Expected departure date</Table.Cell>
          <Table.Cell>
            {(breakClause.expectedDepartureDate &&
              formatDate(breakClause.expectedDepartureDate)) ||
              '-'}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Earliest departure date</Table.Cell>
          <Table.Cell>
            {(breakClause.earliestDepartureDate &&
              formatDate(breakClause.earliestDepartureDate)) ||
              '-'}
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

export default BreakClauseTable;
